/**
 * 文の台帳（spirit）。まとめは ../ui-texts.ts。
 * 管理UIへ写すので、../ui-texts.ts の型の他は何も import しない
 */
import type { UiTextDef } from "../ui-texts";

export const SPIRIT_TEXTS = {
  // 精霊の共通（一覧・最初の精霊を選ぶ・手持ちの札）
  "spirit.common.noName": { text: "???", label: "名前の無い精霊の名前の代わり", note: "精霊の名前がまだ決まっていないとき（獲得精霊の一覧・最初の精霊を選ぶ・ホームの手持ちの行）" },
  "spirit.common.level": { text: "Lv.{レベル}", label: "精霊のレベルの書き方", note: "獲得精霊の一覧と手持ちの札・精霊図鑑の札（その種類でいちばん高いレベル）", vars: "{レベル}" },
  "spirit.portrait.zoom": { text: "{名前}の絵を大きく見る", label: "額を押して絵を大きく見るボタン（読み上げ）", note: "図鑑の詳しい窓の額と、精霊を選んだ画面の大きいカードの額。画面には出ない", vars: "{名前}" },
  "spirit.common.genre": { text: "{属性}属性", label: "精霊の属性の書き方", note: "最初の精霊を選ぶ画面と手持ちの札", vars: "{属性}" },

  // 獲得精霊の一覧（/spirit）
  "spirit.inventory.filterToggle": { text: "絞り込み・並び替え", label: "絞り込み・並び替えの畳んだ行の名前", note: "10/18 から画面には出ない（厚紙の札の読み上げと、指を置いたときの説明）。札には今の選び方が出る" },
  "spirit.inventory.summaryAll": { text: "すべて（{数}）", label: "畳んだ行の右（すべてを出しているとき）", vars: "{数}" },
  "spirit.inventory.summaryRarity": { text: "{レア度}（{数}）", label: "畳んだ行の右（レア度で絞り込んでいるとき）", vars: "{レア度}・{数}" },
  "spirit.inventory.filterHeading": { text: "絞り込み", label: "絞り込みの見出し", note: "畳んだ行を開いたとき" },
  "spirit.inventory.filterAll": { text: "すべて ({数})", label: "絞り込みの「すべて」ボタン", note: "畳んだ行を開いたとき", vars: "{数}" },
  "spirit.inventory.filterRarity": { text: "{レア度} ({数})", label: "絞り込みのレア度ボタン", note: "畳んだ行を開いたとき", vars: "{レア度}・{数}" },
  "spirit.inventory.sortHeading": { text: "並び替え", label: "並び替えの見出し", note: "畳んだ行を開いたとき" },
  "spirit.inventory.sortAcquiredDesc": { text: "入手順↓", label: "並び替え（新しく入手した順）", note: "畳んだ行の右にも出る" },
  "spirit.inventory.sortAcquiredAsc": { text: "入手順↑", label: "並び替え（古く入手した順）", note: "畳んだ行の右にも出る" },
  "spirit.inventory.sortAlpha": { text: "あいうえお", label: "並び替え（名前の順）", note: "畳んだ行の右にも出る" },
  "spirit.inventory.sortRarity": { text: "レア度", label: "並び替え（レア度の順）", note: "畳んだ行の右にも出る" },
  "spirit.inventory.encyclopedia": { text: "精霊 / 素材図鑑を見る", label: "図鑑へのボタン" },
  "spirit.inventory.emptyNone": { text: "まだ精霊がいません", label: "一覧が空のとき（精霊が1体もいない）" },
  "spirit.inventory.emptyFiltered": { text: "該当する精霊がいません", label: "一覧が空のとき（絞り込みに合う精霊がいない）" },
  "spirit.inventory.toGacha": { text: "精霊ガチャを引く", label: "一覧が空のときのボタン", note: "精霊が1体もいないとき" },
  "spirit.inventory.onAdventure": { text: "旅の途中", label: "精霊の札の上の印（旅に出ているとき）" },
  "spirit.inventory.active": { text: "手持ち", label: "精霊の札の上の印（手持ちのとき）" },
  "spirit.inventory.adventureDone": { text: "期間済み", label: "旅の残り時間（帰る時刻を過ぎたとき）" },
  "spirit.inventory.adventureHours": { text: "{時}h{分}m", label: "旅の残り時間（1時間以上）", note: "分は2桁", vars: "{時}・{分}" },
  "spirit.inventory.adventureMinutes": { text: "{分}m{秒}s", label: "旅の残り時間（1分以上）", note: "秒は2桁", vars: "{分}・{秒}" },
  "spirit.inventory.adventureSeconds": { text: "{秒}s", label: "旅の残り時間（1分未満）", vars: "{秒}" },

  // 最初の精霊を選ぶ（/spirit/choose）
  "spirit.choose.loadFailed": { text: "精霊データの読み込みに失敗しました", label: "読み込みに失敗したときの知らせ" },
  "spirit.choose.chooseFailed": { text: "選択に失敗しました", label: "手持ちにできなかったときの知らせ", note: "理由が分からないときだけ（分かるときはその理由が出る）" },
  "spirit.choose.confirmedTitle": { text: "契約成立！", label: "選んだあとの演出の大きな文" },
  "spirit.choose.confirmedJoined": { text: "が手持ちに加わりました", label: "選んだあとの演出の文", note: "精霊の名前の下の行" },
  "spirit.choose.title": { text: "最初の精霊を選ぼう", label: "画面の見出し" },
  "spirit.choose.intro": { text: "あなたの冒険に寄り添う精霊を1体選んでください", label: "見出しの下の説明" },
  "spirit.choose.empty": { text: "選択可能な精霊がまだ登録されていません", label: "選べる精霊がいないとき" },
  "spirit.choose.rarity": { text: "UR", label: "精霊の札のレア度の印" },
  "spirit.choose.maxEvolutions": { text: " / 最大{段階}段階進化", label: "選んだ精霊の詳しい行（進化の段階）", note: "属性の後ろに付く。進化できる精霊だけ", vars: "{段階}" },
  "spirit.choose.crossEvolve": { text: " / 転進化可能", label: "選んだ精霊の詳しい行（転進化）", note: "転進化できる精霊だけ" },
  "spirit.choose.choosing": { text: "契約中...", label: "決定ボタン（送っているあいだ）" },
  "spirit.choose.submit": { text: "この精霊を手持ちにする", label: "決定ボタン" },

  // 手持ち精霊の画面（/party）
  "spirit.party.skillsLoading": { text: "スキルを読み込み中...", label: "スキルを読み込んでいるあいだ" },
  "spirit.party.heading": { text: "手持ち精霊（{数}/{枠}）", label: "手持ち精霊の見出し", vars: "{数}・{枠}" },
  "spirit.party.skillLocked": { text: "未解放", label: "精霊の札の下のスキルの札の末尾（まだ解放していないスキル）", note: "破線の枠と錠の印の札の右端に小さく出る" },
  "spirit.party.receivedExp": { text: "受けるEXP ×{倍率}", label: "精霊の札の下の印（ほかの精霊から受けるEXPの倍率）", note: "倍率が1より大きいとき", vars: "{倍率}" },
  "spirit.party.emptySlot": { text: "空き枠", label: "空き枠の行の名前" },
  "spirit.party.emptySlotChoose": { text: "獲得精霊から選ぶ ›", label: "空き枠の行のボタンの文" },
  "spirit.party.none": { text: "手持ち精霊が設定されていません", label: "手持ちがいないとき" },
  "spirit.party.noneChoose": { text: "獲得精霊から選ぶ", label: "手持ちがいないときのボタン" },

  // 手持ちの札（手持ち精霊の画面の1体ずつ）
  "spirit.card.exp": { text: "経験 {経験値} / {必要経験値}", label: "手持ちの札の経験値", note: "手持ち精霊の画面の紺の板の、斜線のゲージの下の右", vars: "{経験値}・{必要経験値}" },

  // ホームの手持ち精霊の行
  "spirit.partyRow.compact": { text: "精霊 {数}/{枠}", label: "ホームの手持ちの行（狭い列）", note: "広い画面の右の列", vars: "{数}・{枠}" },
  "spirit.partyRow.title": { text: "手持ち精霊（{数}/{枠}）", label: "ホームの手持ちの行の名前", vars: "{数}・{枠}" },
} as const satisfies Record<string, UiTextDef>;
